const formStyle = {
    control: (base: any, state: any) => ({
        ...base,
        border: state.isFocused ? "1px solid var(--primary-color) !important" : "1px solid var(--primary-color)",
        borderRadius: "0px",
        backgroundColor: state.isDisabled ? "var(--primary-color)" : "#fff",
        boxShadow: "none",
        minHeight: "45px",
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        pointerEvents: "auto",
    }),
    placeholder: (base: any, state: any) => ({
        ...base,
        color: state.isDisabled ? "var(--text-color2)" : "var(--text-color1)",
        backgroundColor: "transparent",
        fontSize: "14px",
    }),
    menu: (base: any) => ({
        ...base,
        overflowY: "auto",
        scrollbarWidth: "none",
        color: "var(--text-color)",
        zIndex: 1,
    }),
    menuList: (base: any) => ({
        ...base,
        maxHeight: "160px",
    }),
    menuPortal: (base: any) => ({
        ...base,
        zIndex: 2,
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isFocused ? "#eee" : "",
        color: "var(--text-color1)",
        fontWeight: state.isSelected ? "bold" : "",
    }),
    singleValue: (base: any, state: any) => ({
        ...base,
        color: state.selectProps.menuIsOpen ? "var(--input-color)" : state.isSelected ? "var(--text-color1)" : "var(--text-color1)",
    }),
    multiValueRemove: (base: any) => ({
        ...base,
        color: 'red',
    }),
    dropdownIndicator: (base: any, state: any) => ({
        ...base,
        color: state.isDisabled ? "gray" : base.color,
    }),
};

export default formStyle;